import React from 'react';
import PropTypes from 'prop-types';
import styles from './answerKeys.scss';
import sectionAnswerKeysSelector from '../../selectors/answerKeys/SectionAnswerKeysSelector';
import QuestionAnswerKeys from './QuestionAnswerKeys';

const SectionAnswerKeysPure = (props) => {
    const {
        sectionAnswerKeys,
        sectionTitle,
    } = props;

    const getScorableItemTitleRow = (itemAnswerKeys) => {
        const childKey = `${itemAnswerKeys.contentRevisionId}-${itemAnswerKeys.orderNumber}`;

        return (<tr key={childKey}>
            <td className={styles.questionNumber}>
                {itemAnswerKeys.orderNumber}
            </td>

            <td>
                <QuestionAnswerKeys
                    isMatchingQuestion={itemAnswerKeys.isMatchingQuestion}
                    itemIndex={itemAnswerKeys.itemIndex}
                    answerKeys={itemAnswerKeys.keys}
                />
            </td>
        </tr>);
    };

    return (<React.Fragment>
        <tr className={styles.sectionRow}>
            <td colSpan={2}>
                { sectionTitle }
            </td>
        </tr>

        { sectionAnswerKeys.map(getScorableItemTitleRow) }

    </React.Fragment>);
};

SectionAnswerKeysPure.propTypes = {
    sectionAnswerKeys: PropTypes.array.isRequired,
    sectionTitle: PropTypes.string.isRequired,
};

const SectionAnswerKeys = props => (
    <SectionAnswerKeysPure {...props} {...sectionAnswerKeysSelector.selectProps(props)} />
);

export default SectionAnswerKeys;

